export default __webpack_public_path__ + "static/media/bethan_iron.b5b852ca.png";